<template>
<div class="mainbody">
  <div style="height:0.1px"></div>
  <!-- 童谣标题 -->
  <div id="headerdiv">
    <div class="headertitle">{{Data.title_cn}}</div>
  </div>

  <!-- 童谣介绍-->
  <div id="textDiv" v-if="Data.description || Data.parent_guide">
    <div class="maintext" v-html="addDiv(Data.description || Data.parent_guide)"></div>
  </div>

<!-- 童谣音频 -->
  <div v-if="Data.media_link">
    <div id="headerdiv">
      <div class="headertitle">{{ lang.media_link }}</div>
    </div>
    <div class="flex-row-center">
        <audio id="media_link" controls="controls" :src="Data.media_link">
        {{ lang.audio_tips }}
        </audio>
    </div>
  </div>

<!-- 童谣动画 -->
  <div v-if="Data.video_link">
    <div id="headerdiv">
      <div class="headertitle">{{ lang.media_video }}</div>
    </div>
    <div class="flex-row-center">
      <iframe id="video_link" class="video_iframe" style="z-index:1;"
        :src="Data.video_link" allowfullscreen="true" frameborder="0"
        :width="MAXWIDTH"
        :height="MAXHEIGHT"
        ></iframe>
    </div>
  </div>

  <div v-if="Data.parent_guide">
      <div id="headerdiv">
        <div class="headertitle">{{ lang.parent_guide }}</div>
      </div>
      <div id="textDiv">
      <div class="maintext" v-html="addDiv(Data.parent_guide)"></div>
      <div class="maintext" v-if="Data.parent_aids_link">{{ lang.parent_aids_link }}:<a id="parant_aids_link" :href="Data.parent_aids_link">{{Data.parent_aids_link}}</a></div>
    </div>
  </div>

</div>
</template>

<script>
require('@/assets/css/resource.css')

import BaseVue from '@/components/BaseVue'

export default {
  name: 'AudioTemplateNew',
  extends: BaseVue,
  data () {
    return {
      Data: Object()
    }
  },
  created: async function(){
    let data_id = this.$route.params.id
    let url = this.GATEWAY_ORIGINAL + 'bigdata/cej_target/query_audio_info/?id=' + data_id
    let that = this;
    await this.getLang()
    document.title = this.lang.AudioTemplateNewTitle
    this.queryData(url, function (data) {
      that.Data = data
      if (that.Data.video_link){
        that.Data.video_link = that.resetVideoSize(that.Data.video_link)
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/resource/AudioNew.vue